
// @ts-nocheck


export const localeCodes =  [
  "en",
  "fr",
  "sv",
  "ch",
  "de",
  "da",
  "dk",
  "nl",
  "no"
]

export const localeLoaders = {
  "en": [],
  "fr": [],
  "sv": [],
  "ch": [],
  "de": [],
  "da": [],
  "dk": [],
  "nl": [],
  "no": []
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "__i18n_config_ts_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n.config.ts",
  "locales": [
    {
      "code": "en",
      "name": "English"
    },
    {
      "code": "fr",
      "name": "French"
    },
    {
      "code": "sv",
      "name": "Swedish"
    },
    {
      "code": "ch",
      "name": "Swedish"
    },
    {
      "code": "de",
      "name": "German"
    },
    {
      "code": "da",
      "name": "Danish"
    },
    {
      "code": "dk",
      "name": "Danish"
    },
    {
      "code": "nl",
      "name": "Dutch"
    },
    {
      "code": "no",
      "name": "Norwegian"
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": null,
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "name": "English",
    "files": []
  },
  {
    "code": "fr",
    "name": "French",
    "files": []
  },
  {
    "code": "sv",
    "name": "Swedish",
    "files": []
  },
  {
    "code": "ch",
    "name": "Swedish",
    "files": []
  },
  {
    "code": "de",
    "name": "German",
    "files": []
  },
  {
    "code": "da",
    "name": "Danish",
    "files": []
  },
  {
    "code": "dk",
    "name": "Danish",
    "files": []
  },
  {
    "code": "nl",
    "name": "Dutch",
    "files": []
  },
  {
    "code": "no",
    "name": "Norwegian",
    "files": []
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
